import React from 'react';
import { Box, Typography} from '@mui/material';

export default function InputStyle({ children, name, topSpace }) {
  return (
    <Box
      sx={{
        position: 'relative',
        mt: topSpace ? '0' : '-8px',
        '& textarea': {
          display: 'block',
          width: '100%',
          bgcolor: '#EDF2F7',
          border: '1px solid #E0E4EC',
          height: 150,
          p: 1,
          borderRadius: 2,
          fontFamily: 'Inter',
        },
      }}
      className="inputStyle"
    >
      <Typography
       
        component="label"
        sx={{
          fontWeight: 600,
          fontFamily: 'Inter',
          fontSize:14,
          display:'block'
        }}
      >
        {name}
      </Typography>
      {children}
    </Box>
  );
}


